import { Box, Typography } from "@mui/material";
import { Show, TabbedShowLayout, useRecordContext } from "react-admin";

import { avatarSize, borderRadius, space, typography } from "../theme/designTokens";
import { OrganizationInfoPanel } from "./OrganizationInfoPanel";
import { OrganizationLocationsList } from "./OrganizationLocationsList";

export interface OrganizationRecord {
  id: string;
  name?: string;
  externalId?: string;
  street?: string;
  postalCode?: string;
  city?: string;
  additionalInfo?: string;
}

const OrganizationAvatar = () => {
  return (
    <Box
      component="img"
      src="/organization.png"
      alt="Organization"
      sx={{
        width: avatarSize.lg,
        height: avatarSize.lg,
        borderRadius: borderRadius.lg,
        objectFit: "cover",
      }}
    />
  );
};

const OrganizationShowActions = () => {
  const record = useRecordContext<OrganizationRecord>();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: space.xs, mb: space.xs }}>
      <OrganizationAvatar />
      <Typography variant="h5" component="h1" sx={{ fontWeight: typography.fontWeight.medium }}>
        {record?.name}
      </Typography>
    </Box>
  );
};

export const OrganizationShow = () => (
  <Show actions={<OrganizationShowActions />}>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Informationen">
        <OrganizationInfoPanel />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Wohnbereiche">
        <OrganizationLocationsList />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
